type FunnelParameters = Partial<Record<"source" | "checkout_option" | "plan", string>>;

declare global {
  interface Window {
    LeadholdFunnel?: {
      track: (event: string, parameters?: FunnelParameters, onceKey?: string) => boolean;
      hasConsent: () => boolean;
    };
  }
}

export function trackFunnel(event: string, parameters?: FunnelParameters, onceKey?: string) {
  return window.LeadholdFunnel?.track(event, parameters, onceKey) ?? false;
}

const pendingKey = "leadhold_pending_payment_v1";

export interface PendingPayment {
  paymentId: string;
  option: "trial" | "monthly";
  createdAt: number;
}

export function rememberPayment(paymentId: string, option: PendingPayment["option"]) {
  if (!window.LeadholdFunnel?.hasConsent()) return;
  try {
    sessionStorage.setItem(pendingKey, JSON.stringify({paymentId, option, createdAt: Date.now()}));
  } catch {}
}

export function readPendingPayment(): PendingPayment | null {
  if (!window.LeadholdFunnel?.hasConsent()) return null;
  try {
    const pending = JSON.parse(sessionStorage.getItem(pendingKey) || "null");
    if (!pending || typeof pending.paymentId !== "string"
      || !["trial", "monthly"].includes(pending.option)
      || typeof pending.createdAt !== "number"
      || Date.now() - pending.createdAt > 24 * 60 * 60 * 1000) return null;
    return pending;
  } catch {
    return null;
  }
}

export function forgetPayment() {
  try { sessionStorage.removeItem(pendingKey); } catch {}
}
